import { useState } from "react";
import useTranslator from "../hooks/useTranslator";
import { Badge, Card } from "../components/design";
import "./helpCenter.css";

const videoData = [
  {
    title: "howToInviteTenants",
    description: "learnHowToSendInvitationsDirectlyToYourTenants",
    url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/howToInviteTenant.mp4",
    duration: "1:20",
  },
  {
    title: "howToAddProperties",
    description: "addAndManagePropertiesEasily",
    url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/howToAddProperties.mp4",
    duration: "0:50",
  },
  {
    title: "sharePropertiesOrTenantsWithOtherWorkspaces",
    description: "shareTenantsOrPropertiesAcrossWorkspaces",
    url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/sharingPropertiesOrTenants.mp4",
    duration: "0:52",
  },
  {
    title: "howToInviteNewMembersToOurWorkspace",
    description: "addTeamMembersAndManageTheirPermissions",
    url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/howToinviteNewMembers.mp4",
    duration: "1:34",
  },
  {
    title: "rentedPropertiesWithAddendums",
    description: "managePropertiesWithRentalContractsAndAddendums",
    url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/propertiesRentedWithAddenda.mp4",
    duration: "1:43",
  },
  // {
  //     title: "howToGetANonPaymentInsurancePolicy",
  //     description: "getNonPaymentInsuranceToProtectYourProperties",
  //     url: "https://cdn-skortorent-dyhsdzf5hmghhdg0.z02.azurefd.net/help-tutorial/propertiesRentedWithAddenda.mp4",
  //     duration: "1:43"
  // },
];

const HelpCenter = () => {
  const { _t } = useTranslator();

  return (
    <div className="help-center main-page-wrapper">
      <header className="help-center__head">
        <h1>{_t("helpCenter")}</h1>
        <p>{_t("learnHowToUseSkorStepByStep")}</p>
      </header>

      <section className="help-center__section">
        <h2>{_t("gettingStarted")}</h2>
        <div className="help-center__grid">
          {videoData.slice(0, 3).map((video, index) => (
            <VideoCard key={index} video={video} t={_t} />
          ))}
        </div>
      </section>

      <section className="help-center__section">
        <h2>{_t("advancedFeatures")}</h2>
        <div className="help-center__grid">
          {videoData.slice(3).map((video, index) => (
            <VideoCard key={index} video={video} t={_t} />
          ))}
        </div>
      </section>
    </div>
  );
};

export default HelpCenter;

const VideoCard = ({ video, t }) => (
  <Card as="div" className="help-video">
    <video className="help-video__media" controls>
      <source src={video.url} type="video/mp4" />
    </video>

    <div className="help-video__body">
      <h3>{t(video.title)}</h3>
      <p>{t(video.description)}</p>
      <Badge tone="neutral">{video.duration}</Badge>
    </div>
  </Card>
);
